module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/up-2-edf568c3e45bb16dccf417fa2c0f3225.svg";